export default "__VITE_ASSET__DFqdqF6j__"